import { VyStack } from '@vy/ui-design-system';
import type { ReactNode } from 'react';

/**
 * Two-column field grid for the modify-panel sections. Every child fills one
 * cell (half-width) and flows 2-per-row; a child that carries
 * `data-field-span="full"` (on itself or any descendant) spans the whole row.
 * Sections just list fields in order — width is the field's own concern.
 */
export function FieldGrid({ children }: { children: ReactNode }) {
  return (
    <VyStack
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
        columnGap: 4,
        rowGap: 2.5,
        '& > [data-field-span="full"], & > *:has([data-field-span="full"])': {
          gridColumn: '1 / -1',
        },
      }}
    >
      {children}
    </VyStack>
  );
}
